import React from "react";
import { BankIcon } from "@picklebet/ui";
import { MethodIcon } from "./MethodIcon";

import * as styles from "./BankMethodIcon.module.scss";

export const BankMethodIcon = () => (
  <MethodIcon className={styles.bankMethodIcon}>
    <BankIcon />
  </MethodIcon>
);
